const FormResources = {

    form_data:{
        daily_assignment_id:    '',
        building_id:            '',
        level_id:               '',
        area_id:                '',
        room_id:                [],
        task_id:                '',
        room_type_id:           '',
        floor_id:               '',
        cost_center_id:         '',
        description:            '',
        status:                 false,
        property_assigned:      false,
        policing_task:          false,
        project_task:           false,
        work_group:             false,
        excluded:               false,
        work_group_alter:       '',
        shift1:                 false,
        shift2:                 false,
        shift3:                 false,
        patient_room:           false,
        frequency:              1,
        frequency_val:          false,
        sunday:                 false,
        monday:                 false,
        tuesday:                false,
        wednesday:              false,
        thursday:               false,
        friday:                 false,
        saturday:               false,
    },


    form_format:[
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Building:',
            model_name: 'building_id',
            ref:        'building_id_input',
            ref_alt:    'building_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Level:',
            model_name: 'level_id',
            ref:        'level_id_input',
            ref_alt:    'level_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Area:',
            model_name: 'area_id',
            ref:        'area_id_input',
            ref_alt:    'area_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-12',
            type:       'select-multiple',
            maxlength:  10,
            disabled:   false,
            step:       '',
            name:       'Rooms:',
            model_name: 'room_id',
            ref:        'room_id_input',
            ref_alt:    'room_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Task:',
            model_name: 'task_id',
            ref:        'task_id_input',
            ref_alt:    'task_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Room type:',
            model_name: 'room_type_id',
            ref:        'room_type_id_input',
            ref_alt:    'room_type_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Floor type:',
            model_name: 'floor_id',
            ref:        'floor_id_input',
            ref_alt:    'floor_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Cost center:',
            model_name: 'cost_center_id',
            ref:        'cost_center_id_input',
            ref_alt:    'cost_center_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Open/Closed:',
            model_name: 'status',
            ref:        'status_input',
            ref_alt:    'status_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Shift 1:',
            model_name: 'shift1',
            ref:        'shift1_input',
            ref_alt:    'shift1_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Shift 2:',
            model_name: 'shift2',
            ref:        'shift2_input',
            ref_alt:    'shift2_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Shift 3:',
            model_name: 'shift3',
            ref:        'shift3_input',
            ref_alt:    'shift3_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-2',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Fq:',
            model_name: 'frequency',
            ref:        'frequency_input',
            ref_alt:    'frequency_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-2',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       '',
            model_name: 'frequency_val',
            ref:        'frequency_val_input',
            ref_alt:    'frequency_val_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Properly assigned:',
            model_name: 'property_assigned',
            ref:        'property_assigned_input',
            ref_alt:    'property_assigned_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Policing task:',
            model_name: 'policing_task',
            ref:        'policing_task_input',
            ref_alt:    'policing_task_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Project task:',
            model_name: 'project_task',
            ref:        'project_task_input',
            ref_alt:    'project_task_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Work group:',
            model_name: 'work_group',
            ref:        'work_group_input',
            ref_alt:    'work_group_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Excluded:',
            model_name: 'excluded',
            ref:        'excluded_input',
            ref_alt:    'excluded_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Work group:',
            model_name: 'work_group_alter',
            ref:        'work_group_alter_input',
            ref_alt:    'work_group_alter_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Patient room:',
            model_name: 'patient_room',
            ref:        'patient_room_input',
            ref_alt:    'patient_room_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-2',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Sun:',
            model_name: 'sunday',
            ref:        'sunday_input',
            ref_alt:    'sunday_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-2',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Mon:',
            model_name: 'monday',
            ref:        'monday_input',
            ref_alt:    'monday_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-2',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Tue:',
            model_name: 'tuesday',
            ref:        'tuesday_input',
            ref_alt:    'tuesday_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-2',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Wed:',
            model_name: 'wednesday',
            ref:        'wednesday_input',
            ref_alt:    'wednesday_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-2',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Thu:',
            model_name: 'thursday',
            ref:        'thursday_input',
            ref_alt:    'thursday_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-2',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Fri:',
            model_name: 'friday',
            ref:        'friday_input',
            ref_alt:    'friday_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-2',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Sat:',
            model_name: 'saturday',
            ref:        'saturday_input',
            ref_alt:    'saturday_input_alt',
            required:   false,
        },

    ],

    status_options:  [
        {
            id:     true,
            name:   'Open',
        },
        {
            id:     false,
            name:   'Closed',
        },
    ],

    boolean_options:  [
        {
            id:     true,
            name:   'Yes',
        },
        {
            id:     false,
            name:   'No',
        },
    ],

    group_options:  [
        {
            id:     true,
            name:   'Group 1',
        },
        {
            id:     false,
            name:   'Group 2',
        },
    ],

    simbol_options:  [
        {
            id:     1,
            name:   '=',
        },
        {
            id:     2,
            name:   '<',
        },
        {
            id:     3,
            name:   '>',
        },
    ],

}

export default FormResources;